import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import { Field, FieldLabel } from '@/components/shadcn/field';
import { Slider } from '@/components/shadcn/slider';
import useLocalSettings from '@/stores/useLocalSettings';

export default function ScaleSetting() {
  const { t } = useTranslation();

  const uiScale = useLocalSettings((state) => state.uiScale);
  const { setUiScale } = useLocalSettings((state) => state.actions);

  useEffect(() => {
    document.documentElement.style.fontSize = `${uiScale}px`;
  }, [uiScale]);

  return (
    <Field className="mb-2">
      <FieldLabel>{t('SETTINGS_SCALE_TITLE')}</FieldLabel>

      <Slider
        min={14}
        max={16}
        value={[uiScale]}
        step={1}
        onValueChange={(value) => setUiScale(value?.[0] ?? uiScale)}
        className="mr-1 w-28"
      />
    </Field>
  );
}
